import PageWrapper from "../components/ui/PageWrapper";
import ProjectCard from "../components/projects/ProjectCard";
import { projects } from "../data/projects";
import { motion } from "framer-motion";

export default function ProjectsPage() {
  return (
    <PageWrapper className="pt-28 pb-20 bg-terminal">
      <div className="max-w-6xl mx-auto px-6">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl md:text-4xl font-bold text-brightText mb-4"
        >
          Projects
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-dimText mb-12 max-w-2xl"
        >
          A selection of research and engineering projects spanning astrophysics,
          particle physics, and AI.
        </motion.p>

        <div className="grid md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <ProjectCard key={project.id} project={project} index={index} />
          ))}
        </div>
      </div>
    </PageWrapper>
  );
}
